import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import "./CompanyHeader.scss";

export default function CompanyHeader({
  reportTitle,
  reportSubtitle,
  fiscalYear,
  onDownloadPdf,
  isGeneratingPdf = false,
  onPrint,
  isGeneratingPrint = false,
}) {
  const [company, setCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const headers = authHeader();
        const response = await axios.get(ApiLink.API_URL + "Companies/getCompanyDetails", { headers });
        if (response.data && response.data.length > 0) {
          setCompany(response.data[0]);
        }
      } catch (error) {
        console.error("Gabim ne marrjen e te dhenave te kompanise:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompany();
  }, []);

  if (isLoading || !company) {
    return (
      <div className="FS__Header__Wrapper">
        <div className="FS__Header__Skeleton" />
      </div>
    );
  }

  return (
    <div className="FS__Header__Wrapper">
      <div className="FS__Header__PrintHeading">
        <p className="FS__Header__PrintCompany">{company.CompanyName}</p>
        <h1 className="FS__Header__PrintTitle">{reportTitle}</h1>
        <p className="FS__Header__PrintMeta">Për periudhën e mbyllur më 31.12.{fiscalYear}</p>
      </div>

      <div className="FS__Header__Top">
        <div className="FS__Header__Title">
          <h1>{reportTitle}</h1>
          {reportSubtitle ? <p>{reportSubtitle}</p> : null}
        </div>
        <div className="FS__Header__Actions">
          <button
            type="button"
            className="FS__Header__Btn"
            onClick={onPrint || (() => window.print())}
            disabled={isGeneratingPrint}
          >
            {isGeneratingPrint ? "Duke printuar..." : "Printo"}
          </button>
          {onDownloadPdf ? (
            <button
              type="button"
              className="FS__Header__Btn FS__Header__Btn--primary"
              onClick={onDownloadPdf}
              disabled={isGeneratingPdf}
            >
              {isGeneratingPdf ? "Duke gjeneruar PDF..." : "PDF"}
            </button>
          ) : null}
        </div>
      </div>

      <hr className="FS__Header__Divider" />

      <div className="FS__Header__Info">
        <div className="FS__Header__InfoItem">
          <p className="FS__Header__InfoLabel">Periudha tatimore</p>
          <p className="FS__Header__InfoValue">31.12.{fiscalYear}</p>
        </div>
        <div className="FS__Header__InfoItem">
          <p className="FS__Header__InfoLabel">Numri Fiskal</p>
          <p className="FS__Header__InfoValue">{company.IdentificationNumber}</p>
        </div>
        <div className="FS__Header__InfoItem">
          <p className="FS__Header__InfoLabel">Emri i tatimpaguesit</p>
          <p className="FS__Header__InfoValue">{company.CompanyName}</p>
        </div>
        <div className="FS__Header__InfoItem">
          <p className="FS__Header__InfoLabel">Adresa</p>
          <p className="FS__Header__InfoValue">{company.Address}</p>
        </div>
        <div className="FS__Header__InfoItem">
          <p className="FS__Header__InfoLabel">Telefoni</p>
          <p className="FS__Header__InfoValue">{company.PhoneNumbers}</p>
        </div>
      </div>
    </div>
  );
}
